import React from 'react';
import { Box, Chip, Stack, Typography } from '@mui/material';
import { filterChipSx } from '../../../designTokens';

export default function CreateFlowStepCard({
  question = '',
  chips = [],
  selectedValue = '',
  onChipSelect,
  disabled = false,
}) {
  return (
    <Stack spacing={1} sx={{ mt: 1.5 }}>
      <Typography variant="body2" component="div" sx={{ whiteSpace: 'pre-wrap', lineHeight: 1.5 }}>
        {question}
      </Typography>
      {selectedValue && (
        <Typography variant="caption" color="text.secondary">
          Selected: {selectedValue}
        </Typography>
      )}
      {Array.isArray(chips) && chips.length > 0 && (
        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
          {chips.map((chip) => (
            <Chip
              key={chip}
              label={chip}
              size="small"
              clickable={!disabled}
              onClick={() => !disabled && onChipSelect?.(chip)}
              variant={selectedValue === chip ? 'filled' : 'outlined'}
              color={selectedValue === chip ? 'primary' : 'default'}
              sx={filterChipSx}
            />
          ))}
        </Box>
      )}
    </Stack>
  );
}
